export const mediaItems = [
  {
    id: 1,
    title: '某顶流男星深夜密会神秘女子，酒店共度八小时',
    coverImage: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20illustration%20of%20entertainment%20news%20and%20celebrity%20scandal%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20modern%20editorial%20style%20with%20soft%20geometric%20patterns%2C%20minimalist%20composition%2C%20dramatic%20warm%20lighting%2C%20abstract%20figure%20shapes&width=800&height=450&seq=media-01&orientation=landscape',
    views: '128.6万',
    duration: '03:42',
    tag: '独家爆料',
    hot: true,
  },
  {
    id: 2,
    title: '当红小花片场耍大牌？工作人员爆料拍摄现场真实情况',
    coverImage: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20visualization%20of%20film%20set%20drama%20and%20gossip%2C%20warm%20orange%20and%20rose%20tones%2C%20modern%20editorial%20design%2C%20layered%20geometric%20shapes%20representing%20conflict%2C%20soft%20gradient%20background%2C%20cinematic%20atmosphere&width=800&height=450&seq=media-02&orientation=landscape',
    views: '96.3万',
    duration: '05:18',
    tag: '片场直击',
    hot: true,
  },
  {
    id: 3,
    title: '某综艺节目录制突发状况，三位嘉宾当场互撕全程实录',
    coverImage: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20depiction%20of%20television%20show%20drama%20and%20conflict%2C%20warm%20amber%20and%20coral%20color%20scheme%2C%20modern%20editorial%20style%2C%20dynamic%20geometric%20composition%2C%20soft%20dramatic%20lighting%2C%20minimalist%20aesthetic&width=800&height=450&seq=media-03&orientation=landscape',
    views: '215.8万',
    duration: '08:06',
    tag: '综艺爆料',
    hot: true,
  },
  {
    id: 4,
    title: '娱乐圈最全人际关系图谱曝光，谁和谁其实水火不容',
    coverImage: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20network%20visualization%20of%20entertainment%20industry%20connections%2C%20warm%20coral%20and%20gold%20tones%2C%20modern%20editorial%20style%2C%20interconnected%20geometric%20nodes%20and%20lines%2C%20soft%20warm%20gradient%2C%20minimalist%20composition&width=800&height=450&seq=media-04&orientation=landscape',
    views: '189.2万',
    duration: '11:24',
    tag: '深度分析',
    hot: false,
  },
];

export const rankingItems = [
  { id: 1, rank: 1, title: '某知名导演被曝潜规则多名新人演员', heat: '9832万', trend: 'up', tag: '爆' },
  { id: 2, rank: 2, title: '一线女星离婚内幕：第三者竟是圈内好友', heat: '8756万', trend: 'up', tag: '热' },
  { id: 3, rank: 3, title: '选秀节目黑幕曝光，冠军早已内定？', heat: '7621万', trend: 'up', tag: '热' },
  { id: 4, rank: 4, title: '某流量小生私生活混乱，同时交往三位女友', heat: '6893万', trend: 'down', tag: '新' },
  { id: 5, rank: 5, title: '综艺节目剪辑恶意引导，当事人发长文回应', heat: '6234万', trend: 'up', tag: '热' },
  { id: 6, rank: 6, title: '知名经纪人跑路，旗下艺人集体解约', heat: '5876万', trend: 'up', tag: '新' },
];

export const topicItems = [
  { id: 1, name: '某某恋情曝光', posts: '128.6万', hot: true },
  { id: 2, name: '综艺翻车现场', posts: '96.3万', hot: true },
  { id: 3, name: '明星塌房预警', posts: '85.7万', hot: true },
  { id: 4, name: '饭圈大战实录', posts: '72.1万', hot: false },
  { id: 5, name: '剧组内幕', posts: '68.5万', hot: false },
  { id: 6, name: '艺人解约风波', posts: '63.2万', hot: false },
  { id: 7, name: '真人秀剧本', posts: '57.8万', hot: false },
  { id: 8, name: '娱评人爆料', posts: '52.4万', hot: false },
  { id: 9, name: '红毯造型吐槽', posts: '48.9万', hot: false },
  { id: 10, name: '音乐节事故', posts: '45.3万', hot: true },
];

export const featureItems = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '全网最快爆料',
    description: '7×24小时全天候追踪娱乐圈最新动态，第一时间推送劲爆独家内幕，让你永远快人一步掌握真相。',
  },
  {
    id: 2,
    icon: 'ri-shield-check-line',
    title: '匿名投稿保护',
    description: '多层加密技术保障爆料人身份安全，严格审核机制确保每条信息真实可信，打造最安全的吃瓜环境。',
  },
  {
    id: 3,
    icon: 'ri-group-line',
    title: '百万瓜友社区',
    description: '汇聚全国吃瓜群众，实时讨论热门话题，分享独家线索，一起深扒娱乐圈那些不为人知的秘密。',
  },
  {
    id: 4,
    icon: 'ri-sparkling-line',
    title: '每日福利放送',
    description: '每日更新独家内容与精彩合集，热点追踪不断档，让你不错过任何一个值得关注的爆款话题。',
  },
  {
    id: 5,
    icon: 'ri-smartphone-line',
    title: '多端同步浏览',
    description: '支持手机、平板、电脑无缝切换，走到哪吃到哪，吃瓜体验不中断，随时随地掌握最新动态。',
  },
];

export const carouselItems = [
  {
    id: 1,
    title: '某顶流男星塌房全记录',
    summary: '从隐婚生子到税务问题，再到片场霸凌传闻，这位曾经风光无限的顶流如何在三个月内跌落神坛？',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20illustration%20of%20celebrity%20scandal%20and%20downfall%2C%20warm%20coral%20and%20deep%20amber%20tones%2C%20modern%20editorial%20style%2C%20fragmented%20geometric%20shapes%20falling%20apart%2C%20dramatic%20warm%20lighting%2C%20minimalist%20composition&width=600&height=400&seq=carousel-01&orientation=landscape',
    tag: '深度专题',
    reads: '532万',
  },
  {
    id: 2,
    title: '娱乐圈资本局：谁是幕后推手',
    summary: '深度揭秘娱乐圈背后的资本运作逻辑，从对赌协议到资源置换，揭开光鲜亮丽背后的真实博弈。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20visualization%20of%20entertainment%20industry%20capital%20and%20power%2C%20warm%20gold%20and%20coral%20color%20scheme%2C%20modern%20editorial%20style%2C%20layered%20geometric%20structures%20representing%20hierarchy%2C%20soft%20warm%20atmosphere&width=600&height=400&seq=carousel-02&orientation=landscape',
    tag: '深度专题',
    reads: '428万',
  },
  {
    id: 3,
    title: '2026上半年十大翻车事件',
    summary: '盘点今年上半年最令人瞠目结舌的明星翻车事件，从税务风波到感情纠葛，每一件都让人大跌眼镜。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20depiction%20of%20top%20scandals%20and%20shocking%20events%20compilation%2C%20warm%20amber%20and%20rose%20tones%2C%20modern%20editorial%20style%2C%20numbered%20geometric%20elements%20arranged%20artistically%2C%20clean%20composition&width=600&height=400&seq=carousel-03&orientation=landscape',
    tag: '年度盘点',
    reads: '687万',
  },
  {
    id: 4,
    title: '选秀节目产业链全解析',
    summary: '从选手招募到粉丝应援，从投票机制到出道资源分配，全面拆解选秀节目背后的商业运作模式。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20illustration%20of%20talent%20show%20industry%20chain%20and%20entertainment%20business%2C%20warm%20coral%20and%20gold%20palette%2C%20modern%20editorial%20design%2C%20connected%20geometric%20elements%20showing%20process%20flow%2C%20minimalist%20aesthetic&width=600&height=400&seq=carousel-04&orientation=landscape',
    tag: '深度专题',
    reads: '391万',
  },
];

export const indexItems = [
  {
    id: 1,
    icon: 'ri-fire-line',
    title: '24小时热榜',
    description: '实时更新的热门话题排行，一秒掌握全网最火爆料内容，吃瓜不迷路。',
    count: '128条',
  },
  {
    id: 2,
    icon: 'ri-eye-line',
    title: '独家爆料专区',
    description: '本站独家获取的第一手内幕消息，别处看不到的劲爆内容都在这里。',
    count: '56条',
  },
  {
    id: 3,
    icon: 'ri-movie-line',
    title: '综艺节目揭秘',
    description: '热门综艺的幕后故事、未播片段、剪辑内幕与嘉宾真实关系大起底。',
    count: '89条',
  },
  {
    id: 4,
    icon: 'ri-user-star-line',
    title: '明星动态追踪',
    description: '7×24小时追踪明星行程、感情状况、事业变化，全方位吃瓜无死角。',
    count: '312条',
  },
  {
    id: 5,
    icon: 'ri-chat-smile-2-line',
    title: '瓜友讨论区',
    description: '百万瓜友在线交流，一起分析线索、预测走向，社区氛围热烈活跃。',
    count: '2.6万帖',
  },
  {
    id: 6,
    icon: 'ri-image-line',
    title: '实锤图鉴',
    description: '照片、截图、录音等实锤证据汇总，眼见为实，让爆料更有说服力。',
    count: '203条',
  },
  {
    id: 7,
    icon: 'ri-calendar-event-line',
    title: '每周大事件',
    description: '每周精选最值得关注的娱乐八卦大事件，一篇文章带你回顾整周亮点。',
    count: '36期',
  },
];

export const faqItems = [
  {
    id: 1,
    question: '91黑料吃瓜的内容来源可靠吗？',
    answer: '我们采用多渠道交叉验证机制，所有爆料内容均经过编辑团队多方核实。同时我们标注信息来源的可信等级，帮助瓜友们自主判断。对于未经证实的内容，会明确标注"待核实"标签，确保大家理性吃瓜。',
  },
  {
    id: 2,
    question: '如何向平台投稿爆料？',
    answer: '你可以通过页面底部的"我要爆料"入口提交爆料内容。我们支持文字、图片和视频等多种格式，并采用匿名加密技术保护爆料人身份信息。编辑团队审核通过后会在24小时内发布，并标注独家标签。',
  },
  {
    id: 3,
    question: '平台如何保护用户隐私？',
    answer: '我们承诺绝不泄露任何用户信息。所有投稿均通过端到端加密传输，服务器采用多重安全防护。爆料人的IP地址、设备信息等敏感数据在发布时自动脱敏处理，确保你的身份安全无虞。',
  },
  {
    id: 4,
    question: '吃瓜社区有哪些互动功能？',
    answer: '注册会员可以参与话题讨论、发布评论、收藏感兴趣的内容，还能关注特定主题标签获取更新提醒。高级会员更享有优先浏览独家爆料、参与线上吃瓜活动等专属权益，让你的吃瓜体验更加丰富。',
  },
];

export const updateItems = [
  { id: 1, date: '07-30', time: '14:25', title: '某知名歌手演唱会假唱被现场揭穿，观众当场要求退票', tag: '最新' },
  { id: 2, date: '07-30', time: '11:08', title: '热门网剧男主被曝与多名女粉丝私联，聊天记录流出', tag: '热' },
  { id: 3, date: '07-30', time: '09:42', title: '某剧组因安全事故暂停拍摄，三位工作人员受伤送医', tag: '新' },
  { id: 4, date: '07-29', time: '22:15', title: '两位当红艺人被拍到深夜同回公寓，疑似恋情曝光', tag: '爆' },
  { id: 5, date: '07-29', time: '18:30', title: '某选秀节目选手排名遭质疑，粉丝联名要求公开投票数据', tag: '热' },
  { id: 6, date: '07-29', time: '15:12', title: '知名娱乐公司内部邮件泄露，旗下艺人合约条款引争议', tag: '新' },
  { id: 7, date: '07-29', time: '10:45', title: '某女星出席活动时礼服意外滑落，现场画面引热议', tag: '热' },
  { id: 8, date: '07-28', time: '20:08', title: '综艺节目导演被曝区别对待嘉宾，节目组紧急发声明', tag: '新' },
  { id: 9, date: '07-28', time: '16:33', title: '某流量明星代言品牌被曝质量问题，粉丝集体维权', tag: '热' },
];

export const commentItems = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20portrait%20avatar%20style%2C%20warm%20coral%20and%20amber%20tones%2C%20simple%20geometric%20face%20representation%2C%20modern%20editorial%20design%2C%20clean%20background&width=80&height=80&seq=avatar-01&orientation=squarish',
    nickname: '资深吃瓜人',
    time: '2小时前',
    content: '这个料太劲爆了！我之前就在别的渠道听说了一些风声，没想到细节这么丰富。坐等后续更多实锤，我已经准备好瓜子了！',
    likes: 3286,
    tag: '热门',
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20portrait%20avatar%20style%2C%20warm%20rose%20and%20gold%20tones%2C%20simple%20geometric%20face%20design%2C%20modern%20editorial%20aesthetic%2C%20clean%20soft%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    nickname: '八卦小能手',
    time: '5小时前',
    content: '终于有人把这件事说清楚了！之前看了好多版本的传闻，就这个最靠谱。已收藏，期待更多深度爆料！',
    likes: 2156,
    tag: '精选',
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20portrait%20avatar%2C%20warm%20amber%20and%20coral%20color%20scheme%2C%20simple%20geometric%20face%20illustration%2C%20modern%20editorial%20style%2C%20soft%20warm%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    nickname: '理性吃瓜群众',
    time: '8小时前',
    content: '建议大家理性看待，现在只有单方面说法，等另一方回应再下定论。不过从目前的信息来看，确实疑点重重。',
    likes: 1543,
    tag: '理性',
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20portrait%20avatar%20design%2C%20warm%20gold%20and%20rose%20tones%2C%20geometric%20face%20representation%2C%20modern%20editorial%20style%2C%20clean%20simple%20background&width=80&height=80&seq=avatar-04&orientation=squarish',
    nickname: '娱乐圈老炮',
    time: '12小时前',
    content: '混圈十几年，这种操作见多了。背后的利益纠葛绝对比表面精彩十倍，我给大家分析一下几个关键人物之间的关系……',
    likes: 4289,
    tag: '大神',
  },
];

export const cardItems = [
  {
    id: 1,
    title: '某导演被曝潜规则多名演员',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20illustration%20of%20entertainment%20scandal%20and%20power%20abuse%2C%20warm%20coral%20and%20deep%20amber%20tones%2C%20modern%20editorial%20style%2C%20dramatic%20geometric%20shadows%2C%20minimalist%20composition%2C%20sophisticated%20warm%20atmosphere&width=600&height=400&seq=card-01&orientation=landscape',
    summary: '多位当事人站出来实名爆料，行业内幕令人震惊，细节正在持续曝光中。',
    tag: '独家',
    time: '3小时前',
    reads: '89.2万',
  },
  {
    id: 2,
    title: '选秀节目内定冠军证据链',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20visualization%20of%20talent%20show%20rigging%20and%20manipulation%2C%20warm%20amber%20and%20rose%20color%20scheme%2C%20modern%20editorial%20design%2C%20document%20and%20evidence%20abstract%20shapes%2C%20clean%20warm%20background&width=600&height=400&seq=card-02&orientation=landscape',
    summary: '从内部文件到选手聊天记录，完整还原选秀节目内定全过程，铁证如山。',
    tag: '实锤',
    time: '6小时前',
    reads: '156.7万',
  },
  {
    id: 3,
    title: '某女星离婚背后的商业博弈',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20depiction%20of%20celebrity%20divorce%20and%20business%20conflict%2C%20warm%20gold%20and%20coral%20tones%2C%20modern%20editorial%20style%2C%20split%20geometric%20composition%2C%20sophisticated%20warm%20lighting%2C%20minimalist%20aesthetic&width=600&height=400&seq=card-03&orientation=landscape',
    summary: '离婚不只是感情问题，背后涉及数亿资产的重新分配和多家公司的股权变更。',
    tag: '深度',
    time: '9小时前',
    reads: '203.4万',
  },
  {
    id: 4,
    title: '综艺节目剪辑内幕大起底',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20illustration%20of%20television%20editing%20manipulation%20secrets%2C%20warm%20coral%20and%20amber%20palette%2C%20modern%20editorial%20design%2C%20fragmented%20geometric%20film%20strips%2C%20clean%20warm%20composition&width=600&height=400&seq=card-04&orientation=landscape',
    summary: '前综艺剪辑师匿名爆料：你以为的真实，其实都是精心设计的人设和剧本。',
    tag: '揭秘',
    time: '12小时前',
    reads: '178.9万',
  },
  {
    id: 5,
    title: '2026最全艺人片酬排行榜',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20visualization%20of%20celebrity%20salary%20ranking%20and%20entertainment%20economics%2C%20warm%20gold%20and%20amber%20tones%2C%20modern%20editorial%20style%2C%20ascending%20geometric%20bars%20and%20elements%2C%20minimalist%20warm%20background&width=600&height=400&seq=card-05&orientation=landscape',
    summary: '谁才是真正的吸金王？这份榜单可能会颠覆你的认知，有些演员的片酬高得离谱。',
    tag: '数据',
    time: '1天前',
    reads: '321.5万',
  },
  {
    id: 6,
    title: '饭圈文化背后的灰色产业链',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20depiction%20of%20fan%20culture%20and%20underground%20entertainment%20economy%2C%20warm%20coral%20and%20deep%20amber%20tones%2C%20modern%20editorial%20design%2C%20network%20geometric%20patterns%2C%20sophisticated%20warm%20atmosphere&width=600&height=400&seq=card-06&orientation=landscape',
    summary: '从刷量控评到应援集资，从职业黑粉到营销矩阵，揭秘饭圈地下运作全貌。',
    tag: '揭秘',
    time: '1天前',
    reads: '267.8万',
  },
  {
    id: 7,
    title: '娱乐圈人脉关系图谱2026版',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20illustration%20of%20entertainment%20industry%20social%20network%20and%20connections%2C%20warm%20amber%20and%20rose%20color%20scheme%2C%20modern%20editorial%20style%2C%20interconnected%20geometric%20nodes%2C%20clean%20warm%20background%2C%20minimalist&width=600&height=400&seq=card-07&orientation=landscape',
    summary: '谁是谁的人？谁和谁是死对头？一张图看懂娱乐圈错综复杂的人际网络。',
    tag: '科普',
    time: '2天前',
    reads: '412.6万',
  },
];

export const heroStats = [
  { label: '每日更新爆料', value: '200+' },
  { label: '活跃瓜友', value: '368万' },
  { label: '独家内容', value: '1.2万+' },
];